module.exports = __webpack_public_path__ + "img/web3.8fe9bb39.png";